import script from "./BirthPopulationChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthPopulationChart.vue?vue&type=script&setup=true&lang=js"

import "./BirthPopulationChart.vue?vue&type=style&index=0&id=153e29ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153e29ff"]])

export default __exports__